<template>
  <div class="gx-cfg custom-el-wrapper">
    <gx-loading :show="loading" />
    <!-- <h1 class="gx-main__title">售后配置</h1> -->

    <!-- Tabs -->
    <div class="gx-cfg__tabs">
      <button
        v-for="(t, i) in configTabs"
        :key="i"
        class="gx-cfg__tab"
        :class="{ 'gx-cfg__tab--on': activeTab === i }"
        @click="changeTab(i)"
      >{{ t }}</button>

    </div>

    <!-- Tab1: 退货收货地址 -->
    <div v-if="activeTab === 0">
      <div v-if="savedTip" class="gx-addr__saved">✓ 退货地址已保存成功！</div>
      <div class="gx-addr__card">
        <div class="gx-addr__card-head">
          <span class="gx-addr__card-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z" stroke="#fff" stroke-width="1.8" stroke-linejoin="round" />
              <circle cx="12" cy="10" r="2.6" stroke="#fff" stroke-width="1.8" />
            </svg>
          </span>
          <div>
            <div class="gx-addr__card-title">退货收货地址配置</div>
            <div class="gx-addr__card-sub">买家退货时将使用此地址，请确保信息准确</div>
          </div>
        </div>
        <div class="gx-addr__form">
          <div class="gx-addr__field">
            <label class="gx-addr__label"><span class="gx-addr__req">*</span>收货人</label>
            <input v-model="form.name" class="gx-addr__input" placeholder="请输入收件人姓名" />
          </div>
          <div class="gx-addr__field">
            <label class="gx-addr__label"><span class="gx-addr__req">*</span>手机号</label>
            <div class="gx-addr__phone">
              <span class="gx-addr__phone-prefix">+86</span>
              <input v-model="form.phone" class="gx-addr__phone-input" placeholder="请输入收件人手机号" type="tel" maxlength="11" />
              <span v-if="form.phone.length === 11" class="gx-addr__phone-ok">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="5.5" stroke="#52C41A" stroke-width="1.1"></circle>
                  <path d="M3.5 6.5l1.5 1.5 4-4" stroke="#52C41A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                格式正确
              </span>
            </div>
            <div class="gx-addr__count"><span :class="{ 'text-red': form.phone.length > 0 }">{{ form.phone.length }}</span>/11</div>
          </div>
          <div class="gx-addr__field">
            <label class="gx-addr__label"><span class="gx-addr__req">*</span>省市区 <span class="gx-addr__dim">— 精确到镇/街道</span></label>
            <div class="gx-addr__region">
              <select v-model="form.province_id" class="gx-addr__select gx-addr__select--blue" @change="onProvince">
                <option value="">省/直辖市</option>
                <option v-for="p in regionLevel(regionData)" :key="p.id" :value="p.id">{{ p.label }}</option>
              </select>
              <select v-model="form.city_id" class="gx-addr__select gx-addr__select--green" @change="onCity">
                <option value="">市</option>
                <option v-for="c in cities" :key="c.id" :value="c.id">{{ c.label }}</option>
              </select>
              <select v-model="form.town_id" class="gx-addr__select gx-addr__select--orange" @change="onTown">
                <option value="">区/县</option>
                <option v-for="t in towns" :key="t.id" :value="t.id">{{ t.label }}</option>
              </select>
              <select v-model="form.street_id" class="gx-addr__select gx-addr__select--purple">
                <option value="">镇/街道</option>
                <option v-for="s in streets" :key="s.id" :value="s.id">{{ s.label }}</option>
              </select>
            </div>
            <div v-if="form.province_id && form.city_id && form.town_id && form.street_id" class="gx-addr__region-ok">
              ✓ {{ regionPathText }}
            </div>
          </div>
          <div class="gx-addr__field">
            <label class="gx-addr__label"><span class="gx-addr__req">*</span>详细地址1</label>
            <textarea v-model="form.detail" class="gx-addr__textarea" rows="3" maxlength="128" placeholder="请输入详细地址（门牌号、楼栋、单元等）"></textarea>
            <div class="gx-addr__count gx-addr__count--right"><span :class="{ 'text-red': form.detail.length > 110 }">{{ form.detail.length }}</span>/128</div>
          </div>
          <div v-if="isComplete" class="gx-addr__preview">
            <div class="gx-addr__preview-title">完整地址预览</div>
            <div class="gx-addr__preview-text">
              <span class="gx-addr__preview-name">{{ form.name }}</span>
              <span class="gx-addr__preview-sep">|</span>
              <span class="gx-addr__mono">{{ form.phone }}</span>
              <br />{{ regionPathText }} {{ form.detail }}
            </div>
          </div>
          <div class="gx-addr__foot">
            <button class="gx-addr__btn gx-addr__btn--primary" :disabled="!isComplete || saving" @click="saveAddress">{{ saving ? '保存中...' : '提交' }}</button>
            <button class="gx-addr__btn" @click="resetAddress">重置</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 自动售后设置 -->
    <div v-if="activeTab === 1">
      <!--自动售后设置-->
      <div class="gx-card">
        <div class="gx-card__title">自动售后设置</div>
        <div class="gx-card__body">
          <div class="gx-card__col">
            <div class="gx-card__label">上家延迟申请售后规则</div>
            <div class="gx-card__radio-group">
              <label v-for="item in delayRules" :key="item.value" class="gx-card__radio" :class="{ 'gx-card__radio--on': cfg.auto_aftersale_delay_rule === item.value }" @click="cfg.auto_aftersale_delay_rule=item.value">
               <span class="gx-card__radio-dot"></span>
                <span>{{item.label}}</span>
              </label>
            </div>
            <div class="gx-card__tip">选择「按价格区间」时，仅对区间内价格的订单延迟申请售后</div>
          </div>
          <div v-if="cfg.auto_aftersale_delay_rule === DELAY_RULE_PRICE_RANGE">
            <div class="gx-card__label">上家延迟申请售后区间</div>
            <div class="gx-card__range">
              <span class="text-gray">最低</span>
              <el-input-number class="gx-card__input-num" size="small" v-model="cfg.auto_aftersale_delay_min_price" placeholder="请输入"  :controls="false"></el-input-number>
              <span class="text-gray" style="font-size: 13px">~</span>
              <span class="text-gray">最高</span>
              <div>
                <el-input-number class="gx-card__input-num" size="small" v-model="cfg.auto_aftersale_delay_max_price" placeholder="请输入"  :controls="false"></el-input-number>
                <span class="gx-card__unit">元</span>
              </div>

            </div>
            <div class="gx-card__tip">最低价格须小于最高价格，且均须大于 0</div>
          </div>
          <div>
            <div class="gx-card__label">自动售后延迟时间</div>
            <div class="gx-card__row">
              <el-input-number class="gx-card__input-num" size="small" v-model="cfg.auto_aftersale_delay" placeholder="请输入"  :controls="false"></el-input-number>
              <div class="gx-card__unit">分钟</div>
            </div>
            <div class="gx-card__tip">自动处理售后前延迟的分钟数，0 表示不延迟</div>
          </div>
          <div>
            <div class="gx-card__label">卖家拒绝售后时自动再申请次数</div>
            <div class="gx-card__row">
              <el-input-number class="gx-card__input-num" size="small" v-model="cfg.auto_retry_apply_refund_num" placeholder="请输入" :precision="0" :controls="false"></el-input-number>
              <div class="gx-card__unit">次</div>
            </div>
            <div class="gx-card__tip">卖家拒绝售后后，系统自动重新申请售后的次数</div>
          </div>
        </div>
      </div>
      <!--售后说明设置-->
      <div class="gx-card">
        <div class="gx-card__title">售后说明设置</div>
        <div class="gx-card__body">
          <div class="gx-card__col">
            <div class="gx-card__label">未发货仅退款说明</div>
            <el-input v-model="cfg.aftersale_carry_refund_desc" placeholder="例：不想买了，谢谢" />
            <div class="gx-card__tip">非必填，申请上家售后时，自动填写的描述</div>
          </div>
          <div class="gx-card__col">
            <div class="gx-card__label">已发货仅退款说明</div>
            <el-input v-model="cfg.aftersale_delivery_refund_desc" placeholder="例：不想买了，谢谢" />
            <div class="gx-card__tip">非必填，申请上家售后时，自动填写的描述</div>
          </div>
          <div class="gx-card__col">
            <div class="gx-card__label">退货退款说明</div>
            <el-input v-model="cfg.aftersale_return_refund_desc" placeholder="例：不想买了，谢谢" />
            <div class="gx-card__tip">非必填，申请上家售后时，自动填写的描述</div>
          </div>
        </div>
      </div>
      <!--高级设置-->
      <div class="gx-card">
        <div class="gx-card__title">高级设置</div>
        <div class="gx-card__body">
          <el-checkbox v-model="cfg.is_auto_cancel_apply" :true-label="1" :false-label="0" label="撤销申请：买家撤销售后申请，自动去上家撤销申请" />
          <div class="gx-card__row">
            <el-checkbox
                v-model="cfg.is_aftersale_retention"
                :true-label="1"
                :false-label="0"
                label="售后挽单：卖出单发起售后挽单时，采购单不申请售后" />
            <el-tooltip placement="top">
              <div slot="content">售后挽单：抖店售后订单自动挽回功能，<el-link type="primary" target="_blank" href="https://fxg.jinritemai.com/ffa/maftersale/aftersale/redeem/assistant?btm_ppre=a2427.b90384.c49158.d0&btm_pre=a2427.b687601.c67024&btm_show_id=889fce19-60e4-42a8-becf-d71b8c4741d5#/">查看详情>></el-link></div>
              <i class="el-icon-question gx-card__unit"></i>
            </el-tooltip>
          </div>
          <div class="gx-card__row">
            <el-checkbox
                v-model="cfg.is_partial_refund_no_auto_apply"
                :true-label="1"
                :false-label="0"
                @change="handlePartialRefundNoAutoApplyChange"
                label="部分退款：卖出单申请部分退款时，采购单不申请售后"
            />
              <el-tooltip placement="top">
                <div slot="content">
                  举例说明：<br/>
                  卖出单宝贝100元，用户申请仅退款50元<br />
                  勾选该设置项：采购单不自动去上家申请售后，需手动申请<br />
                  未勾选该设置项：采购单自动去上家申请售后，退款金额100元
                </div>
                <i class="el-icon-question gx-card__unit"></i>
              </el-tooltip>
          </div>
          <div class="gx-card__row">
            <el-checkbox
                v-model="cfg.is_partial_refund_judge_by_amount"
                :true-label="1"
                :false-label="0"
                :disabled="cfg.is_partial_refund_no_auto_apply !== 1"
                @change="handlePartialRefundJudgeByAmountChange"
                label="卖出单申请部分退款金额低于"
            />
            <el-input-number ref="partialRefundMaxPriceInput" class="gx-card__input-num" size="small" v-model="cfg.partial_refund_no_auto_apply_max_price" placeholder="请输入"
                             :controls="false" :precision="2"  style="margin-left: 6px">
            </el-input-number>
            <span class="gx-card__unit">元时，采购单不申请售后</span>
          </div>
        </div>
      </div>
      <!--卖出单自动售后设置-->
      <div class="gx-card">
        <div class="gx-card__title">卖出单自动售后设置</div>
        <div class="gx-card__body">
          <div class="gx-card__col">
            <div class="gx-card__label">开启自动售后账号</div>
            <div class=""></div>
            <div v-if="cfgAccountList.length" class="pdd-account-list">
              <el-checkbox
                  v-for="item in cfgAccountList"
                  :key="item.id"
                  v-model="item.auto_deal_dd_after_sales"
                  :true-label="1"
                  :false-label="0"
                  :label="`${item.phone || ''}${item.name || ''}`"
              />
            </div>
            <div v-else class="gx-card__tip">暂无采购账号</div>
          </div>
          <div class="gx-card__divider"></div>
          <div>
            <el-checkbox
                v-model="cfg.is_auto_select_supplier_return_address"
                :true-label="1"
                :false-label="0"
                label="退货退款"
                @change="handleAutoSelectSupplierReturnAddressChange"
            />
            <div class="gx-card__tip">同意买家退货退款申请时，自动选择上家退货地址</div>
          </div>
          <el-checkbox
              v-model="cfg.is_skip_select_supplier_return_address_on_pin_tui"
              :true-label="1"
              :false-label="0"
              :disabled="cfg.is_auto_select_supplier_return_address !== 1"
              label="卖出单售后原因为「品退」时自动跳过"
          />
          <el-checkbox
              v-model="cfg.is_skip_select_supplier_return_address_over_ship_days"
              :true-label="1"
              :false-label="0"
              :disabled="cfg.is_auto_select_supplier_return_address !== 1"
              label="卖出单发货超过10天时自动跳过"
          />
          <div>
            <el-checkbox
                v-model="form.is_auto_agree_sell_refund_on_purchase_refund"
                :true-label="1"
                :false-label="0"
                label="同意退款"
                @change="handleAutoAgreeSellRefundChange"
            />
            <div class="gx-card__tip">采购单退款成功后，自动同意卖出单退款申请</div>
          </div>
          <el-checkbox
              v-model="cfg.is_skip_agree_sell_refund_with_postage"
              :true-label="1"
              :false-label="0"
              :disabled="cfg.is_auto_agree_sell_refund_on_purchase_refund !== 1"
              label="已发货卖出单退款金额含运费时自动跳过"
          />
          <div class="gx-card__divider"></div>
          <div class="gx-card__col">
            <div class="gx-card__row">
              <div class="gx-card__label" style="margin-bottom: 0">自动同意售后原因</div>
              <button class="gx-cfg__btn gx-cfg__btn--red gx-cfg__btn--mi" style="margin-left: auto" @click="selectAllReasons">全选</button>
            </div>
            <el-checkbox-group v-model="cfg.auto_refund_reason" class="gx-card__check-group">
              <el-checkbox
                  v-for="item in aftersaleReasonList"
                  :key="item"
                  :label="item"
              />
            </el-checkbox-group>
          </div>
        </div>
      </div>

      <div class="gx-cfg__foot">
        <button class="gx-cfg__btn gx-cfg__btn--red" :disabled="configSaving" @click="saveConfig">保存</button>
        <button class="gx-cfg__btn" @click="loadConfig">重置</button>
      </div>

    </div>
    <!-- 退换货地址删除 -->
    <div v-if="activeTab === 2">
      <div class="gx-card">
        <div class="gx-card__title">退换货地址自动删除天数</div>
        <div class="gx-card__tip gx-card__tip--top">设置退换货地址的自动删除规则，超过条件的地址将自动清理</div>
        <div class="gx-card__row" style="gap: 10px;">
          <el-select v-model="delForm.limit_day" size="small" style="width:150px;">
            <el-option label="7天订单量小于" value="7" />
            <el-option label="15天订单量小于" value="15" />
            <el-option label="30天订单量小于" value="30" />
          </el-select>
          <div class="gx-card__row">
            <el-input-number size="small" class="gx-card__input-num" v-model="delForm.order_num" placeholder="请输入" :controls="false" :precision="0"></el-input-number>
            <div class="gx-card__unit">单</div>
          </div>
          <div class="gx-card__row">
            <el-input-number size="small" class="gx-card__input-num" v-model="delForm.delete_day" placeholder="请输入" :controls="false" :precision="0"></el-input-number>
            <div class="gx-card__unit">天后自动删除</div>
          </div>
        </div>
        <div class="gx-card__example">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="5" stroke="#1677FF" stroke-width="1.1"></circle><path d="M6 5v3M6 3.5v.5" stroke="#1677FF" stroke-width="1.2" stroke-linecap="round"></path></svg>
          <span>示例：</span>
          <span class="text-strong text-red">{{delForm.limit_day}}天订单量小于{{delForm.order_num}}单{{delForm.delete_day}}天后自动删除</span>
        </div>
      </div>
      <div class="gx-cfg__foot">
        <button class="gx-cfg__btn gx-cfg__btn--red" :disabled="deleteSaving" @click="saveDeleteRule">{{ deleteSaving ? '保存中...' : '保存' }}</button>
        <button class="gx-cfg__btn" @click="loadDeleteRule">重置</button>
      </div>
    </div>
    <!-- 获取退货地址时机 -->
    <div v-if="activeTab === 3">
      <div class="gx-card">
        <div class="gx-card__title">获取退货地址时机</div>
        <div class="gx-card__tip gx-card__tip--top">设置系统自动获取上家退货地址的时机和规则</div>
        <div class="gx-card__body">
          <div class="gx-card__col">
            <div class="gx-card__label">获取时间</div>
            <div class="gx-card__row gap-24" >
              <label v-for="item in returnAddressType" :key="item.value" class="gx-card__radio" :class="{ 'gx-card__radio--on': syncForm.sync_return_address_type === item.value }" @click="syncForm.sync_return_address_type=item.value">
                <span class="gx-card__radio-dot"></span>
                <span>{{item.label}}</span>
              </label>
            </div>
          </div>
          <div class="gx-card__col">
            <div class="gx-card__label">快递拦截或订单退款</div>
            <div class="gx-card__row gap-24" >
              <label v-for="item in repurchaseType" :key="item.value" class="gx-card__radio" :class="{ 'gx-card__radio--on': syncForm.repurchase_type === item.value }" @click="syncForm.repurchase_type=item.value">
                <span class="gx-card__radio-dot"></span>
                <span>{{item.label}}</span>
              </label>
            </div>
          </div>
          <div class="gx-card__col">
            <div class="gx-card__label">售后申请次数</div>
            <div class="gx-card__row gap-24" >
              <label v-for="item in refundApplyNum" :key="item.value" class="gx-card__radio" :class="{ 'gx-card__radio--on': syncForm.sync_return_address_refund_apply_num === item.value }" @click="syncForm.sync_return_address_refund_apply_num=item.value">
                <span class="gx-card__radio-dot"></span>
                <span>{{item.label}}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="gx-cfg__foot">
        <button class="gx-cfg__btn gx-cfg__btn--red" :disabled="syncSaving" @click="saveSyncRule">{{ syncSaving ? '保存中...' : '保存' }}</button>
        <button class="gx-cfg__btn" @click="loadSyncRule">重置</button>
      </div>
    </div>
    <under-development ref="underDevelopmentRef"></under-development>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import gxLoading from '../../mixins/gxLoading'
import UnderDevelopment from "@/components/newUi/UnderDevelopment.vue";

const DELAY_RULE_ALL = 10
const DELAY_RULE_PRICE_RANGE = 20
const DEFAULT_FORM = {
  type: 2,
  province_id: '',
  city_id: '',
  town_id: '',
  street_id: '',
  detail: '',
  name: '',
  phone: ''
}

const DEFAULT_CFG = {
  auto_retry_apply_refund_num: '1',
  auto_aftersale_delay_rule: 10,
  auto_aftersale_delay_min_price: '0',
  auto_aftersale_delay_max_price: '0',
  auto_aftersale_delay: '0',
  aftersale_carry_refund_desc: '',
  aftersale_delivery_refund_desc: '',
  aftersale_return_refund_desc: '',
  is_auto_cancel_apply: 0,
  is_partial_refund_no_auto_apply: 0,
  is_partial_refund_judge_by_amount: 0,
  partial_refund_no_auto_apply_max_price: '1.00',
  is_auto_select_supplier_return_address: 0,
  is_skip_select_supplier_return_address_on_pin_tui: 0,
  is_skip_select_supplier_return_address_over_ship_days: 0,
  is_auto_agree_sell_refund_on_purchase_refund: 0,
  is_skip_agree_sell_refund_with_postage: 0,
  auto_refund_reason: []
}

export default {
  name: 'NewAfterAddrPage',
  components: { GxLoading ,UnderDevelopment},
  mixins: [gxLoading],
  props: {
    initialShopType: { type: Number, default: 1 },
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      currentShopType:1,
      configTabs: ['退货收货地址', '自动售后设置', '退换货地址删除', '获取退货地址时机'],
      activeTab: 0,
      savedTip: false,
      saving: false,
      form: { ...DEFAULT_FORM },
      regionData: [],
      // 自动售后设置
      DELAY_RULE_ALL,
      DELAY_RULE_PRICE_RANGE,
      cfg: JSON.parse(JSON.stringify(DEFAULT_CFG)),
      cfgAccountList: [],
      aftersaleReasonList: [],
      configSaved: false,
      configSaving: false,
      delayRules:[{label:'全部',value:DELAY_RULE_ALL},{label:'按价格区间',value:DELAY_RULE_PRICE_RANGE}],
      // 退换货地址删除
      delForm: { limit_day: '7', order_num: '', delete_day: '' },
      deleteSaved: false,
      deleteSaving: false,
      // 获取退货地址时机
      returnAddressType:[{label:'发货后24小时',value:10},{label:'签收后',value:20}],
      repurchaseType:[{label:'自动重拍',value:10},{label:'手动重拍',value:20}],
      refundApplyNum:[{label:'1次',value:1},{label:'2次',value:2}],
      syncForm: { sync_return_address_type: 10, repurchase_type: 10, sync_return_address_refund_apply_num: 1 },
      syncSaved: false,
      syncSaving: false
    }
  },
  computed: {
    cities() {
      const p = this.regionData.find((x) => String(x.id) === String(this.form.province_id))
      return p ? (p.children || []) : []
    },
    towns() {
      const p = this.regionData.find((x) => String(x.id) === String(this.form.province_id))
      const c = p ? (p.children || []).find((x) => String(x.id) === String(this.form.city_id)) : null
      return c ? (c.children || []) : []
    },
    streets() {
      const p = this.regionData.find((x) => String(x.id) === String(this.form.province_id))
      const c = p ? (p.children || []).find((x) => String(x.id) === String(this.form.city_id)) : null
      const t = c ? (c.children || []).find((x) => String(x.id) === String(this.form.town_id)) : null
      return t ? (t.children || []) : []
    },
    regionPathText() {
      const p = this.regionData.find((x) => String(x.id) === String(this.form.province_id))
      const c = p ? (p.children || []).find((x) => String(x.id) === String(this.form.city_id)) : null
      const t = c ? (c.children || []).find((x) => String(x.id) === String(this.form.town_id)) : null
      const s = t ? (t.children || []).find((x) => String(x.id) === String(this.form.street_id)) : null
      return [p && p.label, c && c.label, t && t.label, s && s.label].filter(Boolean).join(' ')
    },
    isComplete() {
      return !!(this.form.name.trim() && this.form.phone.trim() && this.form.province_id && this.form.city_id && this.form.town_id && this.form.street_id && this.form.detail.trim())
    }
  },
  watch:{
    initialShopType(val){
      this.currentShopType =val
      if(this.currentShopType===7){
        this.$nextTick(()=>{
          this.$refs.underDevelopmentRef.show()
        })
        return
      }
      this.initData()
    }
  },
  created() {
    this.currentShopType =this.initialShopType
    this.loadingStart()
    if(this.currentShopType===7){
      this.$nextTick(()=>{
        this.$refs.underDevelopmentRef.show()
      })
      return
    }
    this.getRegionData({
      data: {},
      success: (res) => {
        this.loadingEnd()
        if (res.code === 200) {
          this.regionData = res.data || []
          this.initData()
        }
      }
    })
  },
  methods: {
    ...mapActions({
      getRegionData: 'ucenter_order/getRegionData',
      getBusinessAddressInfo: 'ucenter_order/getBusinessAddressInfo',
      opEditBusinessAddress: 'ucenter_order/opEditBusinessAddress',
      getUserinfoData: 'ucenter_order/getUserinfoData',
      opBusinessSetAftersaleConfig: 'ucenter_order/opBusinessSetAftersaleConfig',
      getStrategyDeleteSet: 'ucenter_order/getStrategyDeleteSet',
      opEditStrategyDeleteSet: 'ucenter_order/opEditStrategyDeleteSet',
      opBusinessSetSyncReturnAddressType: 'ucenter_order/opBusinessSetSyncReturnAddressType'
    }),
    regionLevel(data) {
      return data || []
    },
    initData(){
      this.loadAddress()
      this.loadConfig()
      this.loadDeleteRule()
      this.loadSyncRule()
    },
    changeTab(i){
      this.activeTab = i
     /* if(this.currentShopType===7) return
      switch (i){
        case 0: this.loadAddress(); break;
        case 1: this.loadConfig(); break;
      }*/
    },
    /**
     *  ── Tab1 地址 ── */
    loadAddress() {
      this.loadingStart()
      this.getBusinessAddressInfo({
        data: { type: 2 },
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            const a = res.data || {}
            this.form = Object.assign({ ...DEFAULT_FORM }, a, { type: 2 })
          }
        }
      })
    },
    onProvince() {
      this.form.city_id = ''
      this.form.town_id = ''
      this.form.street_id = ''
    },
    onCity() {
      this.form.town_id = ''
      this.form.street_id = ''
    },
    onTown() {
      this.form.street_id = ''
    },
    resetAddress() {
      this.loadAddress()
    },
    saveAddress() {
      if (this.currentShopType===7) {
        this.$message({ message: '该功能开发中，敬请期待', type: 'warning' })
        return
      }
      if (!this.form.name.trim()) {
        this.$message.error('请输入收货人姓名')
        return
      }
      if (!/^1\d{10}$/.test(this.form.phone)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.form.province_id || !this.form.city_id || !this.form.town_id || !this.form.street_id) {
        this.$message.error('请选择省市区（精确到镇/街道）')
        return
      }
      if (!this.form.detail.trim()) {
        this.$message.error('请输入详细地址')
        return
      }
      if (this.saving) return
      this.saving = true
      this.opEditBusinessAddress({
        data: Object.assign({}, this.form, { type: 2 }),
        success: (res) => {
          this.saving = false
          if (res.code === 200) {
            this.savedTip = true
            setTimeout(() => { this.savedTip = false }, 2800)
            this.$message.success(res.msg || '保存成功')
            this.loadAddress()
          } else {
            this.$message.error(res.msg || res.message)
          }
        }
      })
    },
    /**
     *  ── Tab2 自动售后设置 ── */
    loadConfig() {
      this.aftersaleReasonList = []
      this.cfgAccountList = []
      this.cfg = JSON.parse(JSON.stringify(DEFAULT_CFG))
      this.loadingStart()
      this.getUserinfoData({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.aftersaleReasonList = Array.isArray(res.data.aftersale_reason_list) ? res.data.aftersale_reason_list : []
            this.cfgAccountList = (Array.isArray(res.data.pdd_account_list) ? res.data.pdd_account_list : []).map((item) => ({
              id: item.id,
              phone: item.phone || '',
              name: item.name || '',
              auto_deal_dd_after_sales: Number(item.auto_deal_dd_after_sales) === 1 ? 1 : 0
            }))
            Object.keys(DEFAULT_CFG).forEach((key) => {
              if (res.data[key] !== undefined && res.data[key] !== null) {
                this.cfg[key] = res.data[key]
              }
            })
            if (!Array.isArray(this.cfg.auto_refund_reason)) this.cfg.auto_refund_reason = []
          }
          this.loadingEnd()
        }
      })
    },
    handlePartialRefundNoAutoApplyChange(val) {
      if (val !== 1) {
        this.cfg.is_partial_refund_judge_by_amount = 0
      }
    },
    handlePartialRefundJudgeByAmountChange(val) {
      if (val !== 1) return
      const result = this.validatePartialRefundMaxPrice(true)
      if (!result.valid) {
        this.cfg.is_partial_refund_judge_by_amount = 0
        this.focusPartialRefundMaxPriceInput()
      }
    },
    validatePartialRefundMaxPrice(showMessage = true) {
      const str = String(this.cfg.partial_refund_no_auto_apply_max_price ?? '').trim()
      const label = '部分退款不自动申请最高金额'
      if (str === '') {
        if (showMessage) {
          this.$message({ message: `${label}必须大于0`, type: 'warning' })
        }
        return { valid: false, value: null }
      }
      if (!/^\d+(\.\d+)?$/.test(str)) {
        if (showMessage) {
          this.$message({ message: `${label}必须大于0`, type: 'warning' })
        }
        return { valid: false, value: null }
      }
      const value = parseFloat(str)
      if (value <= 0) {
        if (showMessage) {
          this.$message({ message: `${label}必须大于0`, type: 'warning' })
        }
        return { valid: false, value: null }
      }
      return { valid: true, value }
    },
    focusPartialRefundMaxPriceInput() {
      this.$nextTick(() => {
        const inputRef = this.$refs.partialRefundMaxPriceInput
        if (inputRef && inputRef.focus) {
          inputRef.focus()
        }
      })
    },
    handleAutoSelectSupplierReturnAddressChange(val) {
      if (val !== 1) {
        this.cfg.is_skip_select_supplier_return_address_on_pin_tui = 0
        this.cfg.is_skip_select_supplier_return_address_over_ship_days = 0
      }
    },
    handleAutoAgreeSellRefundChange(val) {
      if (val !== 1) {
        this.cfg.is_skip_agree_sell_refund_with_postage = 0
      }
    },
    selectAllReasons() {
      if (this.cfg.auto_refund_reason.length === this.aftersaleReasonList.length) {
        this.cfg.auto_refund_reason = []
      } else {
        this.cfg.auto_refund_reason = this.aftersaleReasonList.slice()
      }
    },
    saveConfig() {
      if (this.currentShopType===7) {
        this.$message({ message: '该功能开发中，敬请期待', type: 'warning' })
        return
      }
      if (Number(this.cfg.auto_retry_apply_refund_num) < 0) {
        this.$message.warning('自动再申请售后次数不能小于 0')
        return
      }
      if (Number(this.cfg.auto_aftersale_delay) < 0) {
        this.$message.warning('自动售后延迟时间不能小于 0')
        return
      }
      if (Number(this.cfg.auto_aftersale_delay_rule) === DELAY_RULE_PRICE_RANGE) {
        if (Number(this.cfg.auto_aftersale_delay_min_price) <= 0 || Number(this.cfg.auto_aftersale_delay_max_price) <= 0) {
          this.$message.warning('延迟申请售后价格区间不能为 0')
          return
        }
        if (Number(this.cfg.auto_aftersale_delay_min_price) >= Number(this.cfg.auto_aftersale_delay_max_price)) {
          this.$message.warning('延迟申请售后最低价格须小于最高价格')
          return
        }
      }
      if (this.cfg.is_partial_refund_judge_by_amount === 1 && this.cfg.is_partial_refund_no_auto_apply !== 1) {
        this.$message.warning('请先开启部分退款不自动申请售后')
        return
      }
      if (this.cfg.is_partial_refund_judge_by_amount === 1) {
        const partialRefundResult = this.validatePartialRefundMaxPrice(true)
        if (!partialRefundResult.valid) {
          this.focusPartialRefundMaxPriceInput()
          return
        }
        this.cfg.partial_refund_no_auto_apply_max_price = partialRefundResult.value
      }
      if (this.cfg.is_auto_select_supplier_return_address !== 1  && (
              this.cfg.is_skip_select_supplier_return_address_on_pin_tui === 1
              || this.cfg.is_skip_select_supplier_return_address_over_ship_days === 1
          )
      ) {
        this.$message({ message: '请先开启同意买家退货退款时自动选择上家退货地址', type: 'warning' })
        return
      }
      if ( this.cfg.is_auto_agree_sell_refund_on_purchase_refund !== 1 && this.cfg.is_skip_agree_sell_refund_with_postage === 1 ) {
        this.$message({ message: '请先开启采购单退款成功后自动同意卖出单退款申请', type: 'warning' })
        return
      }
      if (this.configSaving) return
      this.configSaving = true
      const data = {
        auto_retry_apply_refund_num: String(this.cfg.auto_retry_apply_refund_num),
        auto_aftersale_delay_rule: Number(this.cfg.auto_aftersale_delay_rule),
        auto_aftersale_delay_min_price: String(this.cfg.auto_aftersale_delay_min_price),
        auto_aftersale_delay_max_price: String(this.cfg.auto_aftersale_delay_max_price),
        auto_aftersale_delay: String(this.cfg.auto_aftersale_delay),
        aftersale_carry_refund_desc: this.cfg.aftersale_carry_refund_desc,
        aftersale_delivery_refund_desc: this.cfg.aftersale_delivery_refund_desc,
        aftersale_return_refund_desc: this.cfg.aftersale_return_refund_desc,
        is_auto_cancel_apply: Number(this.cfg.is_auto_cancel_apply),
        is_partial_refund_no_auto_apply: Number(this.cfg.is_partial_refund_no_auto_apply),
        is_partial_refund_judge_by_amount: Number(this.cfg.is_partial_refund_judge_by_amount),
        partial_refund_no_auto_apply_max_price: String(this.cfg.partial_refund_no_auto_apply_max_price),
        is_auto_select_supplier_return_address: Number(this.cfg.is_auto_select_supplier_return_address),
        is_skip_select_supplier_return_address_on_pin_tui: Number(this.cfg.is_skip_select_supplier_return_address_on_pin_tui),
        is_skip_select_supplier_return_address_over_ship_days: Number(this.cfg.is_skip_select_supplier_return_address_over_ship_days),
        is_auto_agree_sell_refund_on_purchase_refund: Number(this.cfg.is_auto_agree_sell_refund_on_purchase_refund),
        is_skip_agree_sell_refund_with_postage: Number(this.cfg.is_skip_agree_sell_refund_with_postage),
        auto_refund_reason: this.cfg.auto_refund_reason || [],
        pdd_account_list: this.cfgAccountList.map((item) => ({
          id: item.id,
          auto_deal_dd_after_sales: Number(item.auto_deal_dd_after_sales)
        }))
      }
      this.opBusinessSetAftersaleConfig({
        data,
        success: (res) => {
          this.configSaving = false
          if (res.code === 200) {
            this.configSaved = true
            setTimeout(() => { this.configSaved = false }, 2200)
            this.$message.success(res.msg || '保存成功')
          } else {
            this.$message.error(res.msg || res.message)
          }
        }
      })
    },

    /**
     *  ── Tab3 退换货地址删除 ── */
    loadDeleteRule() {
      this.loadingStart()
      this.getStrategyDeleteSet({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            const d = res.data || {}
            this.delForm = {
              limit_day: d.limit_day != null && d.limit_day !== '' ? String(d.limit_day) : '7',
              order_num: d.order_num != null && d.order_num !== '' ? String(d.order_num) : '',
              delete_day: d.delete_day != null && d.delete_day !== '' ? String(d.delete_day) : ''
            }
          }
          this.loadingEnd()
        }
      })
    },
    saveDeleteRule() {
      if (this.currentShopType===7) {
        this.$message({ message: '该功能开发中，敬请期待', type: 'warning' })
        return
      }
      if (this.deleteSaving) return
      this.deleteSaving = true
      this.opEditStrategyDeleteSet({
        data: this.delForm,
        success: (res) => {
          this.deleteSaving = false
          if (res.code === 200) {
            this.deleteSaved = true
            setTimeout(() => { this.deleteSaved = false }, 2200)
            this.$message.success(res.msg || '保存成功')
          } else {
            this.$message.error(res.msg || res.message)
          }
        }
      })
    },
    /**
     *  ── Tab4 获取退货地址时机 ── */
    loadSyncRule() {
      this.loadingStart()
      this.getUserinfoData({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.syncForm.sync_return_address_type = res.data.sync_return_address_type != null ? Number(res.data.sync_return_address_type) : 10
            this.syncForm.repurchase_type = res.data.repurchase_type != null ? Number(res.data.repurchase_type) : 10
            this.syncForm.sync_return_address_refund_apply_num = res.data.sync_return_address_refund_apply_num != null ? Number(res.data.sync_return_address_refund_apply_num) : 1
          }
          this.loadingEnd()
        }
      })
    },
    saveSyncRule() {
      if (this.currentShopType===7) {
        this.$message({ message: '该功能开发中，敬请期待', type: 'warning' })
        return
      }
      if (this.syncSaving) return
      this.syncSaving = true
      this.opBusinessSetSyncReturnAddressType({
        data: this.syncForm,
        success: (res) => {
          this.syncSaving = false
          if (res.code === 200) {
            this.syncSaved = true
            setTimeout(() => { this.syncSaved = false }, 2200)
            this.$message.success(res.msg || '保存成功')
          } else {
            this.$message.error(res.msg || res.message)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

.gap-24{
  gap: 24px;
}
.text-gray{
  color: #999999;
}

.text-strong{
  font-weight: 600;
}
.gx-cfg__tabs {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 2px solid rgb(224, 224, 236);
  flex-wrap: wrap;
}
.gx-cfg__tab {
  padding: 9px 18px;
  border-bottom: 2px solid transparent;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  color: #666666;
  font-weight: 400;
  margin-bottom: -2px;
  transition: 0.18s;
  white-space: nowrap;
}
.gx-cfg__tab~.gx-cfg__tab{
  border-left: 1px solid #e0e0ec;
}
.gx-cfg__tab--on {
  color: var(--gx-red);
  font-weight: 600;
  border-bottom: 2px solid var(--gx-red);

}

.gx-addr__saved {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  background: #F6FFED;
  border: 1px solid #B7EB8F;
  font-size: 13px;
  color: #52C41A;
  font-weight: 500;
}
.gx-addr__card {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #EBEEF5;
  -webkit-box-shadow: 0 2px 12px rgba(0, 0, 0, .06);
  box-shadow: 0 2px 12px rgba(0, 0, 0, .06);
  overflow: hidden;
  margin-bottom: 14px;
  width: 650px;
}
.gx-addr__card-head {
  padding: 14px 22px;
  border-bottom: 1px solid rgb(224, 224, 236);
  background: rgb(245, 240, 232);
  display: flex;
  align-items: center;
  gap: 10px;
}
.gx-addr__card-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gx-addr__card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-addr__card-sub {
  font-size: 11px;
  color: #999999;
  margin-top: 2px;
}
.gx-addr__section-title {
  font-size: 14px;
  font-weight: 700;
  color: #1A1A2E;
  padding: 14px 22px;
  border-bottom: 1px solid #E1E5EE;
  background: #F5F0E8;
}
.gx-addr__form {
  padding: 22px 22px 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.gx-addr__field {
  display: flex;
  flex-direction: column;
}
.gx-addr__label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: #666666;
}

.gx-addr__req {
  font-size: 13px;
  color: var(--gx-red);
}
.gx-addr__dim {
  color: #999999;
  font-size: 10px;
  font-weight: 400;
}
.gx-addr__input {
  width: 100%;
  height: 40px;
  padding: 0 14px;
  border-radius: 6px;
  border: 1px solid #E5E7EB;
  font-size: 14px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  transition: border .15s;
}
.gx-addr__input:focus {
  border-color: var(--gx-red);
  box-shadow: rgba(200,68,60,0.3) 0 0 0 3px;
}

.gx-addr__textarea {
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1.5px solid rgb(224, 224, 236);;
  font-size: 14px;
  color: #1A1A2E;
  outline: none;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;
  line-height: 1.6;
  transition: border .15s;
}
.gx-addr__textarea:focus {
  border-color: var(--gx-red);
  box-shadow: rgba(200,68,60,0.3) 0 0 0 3px;
}
.gx-addr__phone {
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #E5E7EB;
  overflow: hidden;
  transition: border .15s;
}
.gx-addr__phone:focus-within {
  border-color: var(--gx-red);
  box-shadow: rgba(200,68,60,0.3) 0 0 0 3px;
}
.gx-addr__phone-prefix {
  padding: 0 12px;
  background: #f5f0e8;
  border-right: 1px solid rgb(224, 224, 236);;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #666666;
  flex-shrink: 0;
}
.gx-addr__phone-input {
  flex: 1;
  height: 100%;
  padding: 0 14px;
  border: none;
  outline: none;
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
  color: #1A1A2E;
  letter-spacing: .06em;
}
.gx-addr__phone-ok {
  padding-right: 12px;
  font-size: 11px;
  color: #52C41A;
  white-space: nowrap;
}
.gx-addr__count {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: #6A6A8A;
}
.gx-addr__count--right {
  text-align: right;
}

.gx-addr__region {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.gx-addr__select {
  height: 40px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #E5E7EB;
  background: #FFFFFF;
  font-size: 13px;
  font-weight: 500;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
}
.gx-addr__select--blue  { color: var(--gx-cyan); }
.gx-addr__select--green { color: var(--gx-green); }
.gx-addr__select--orange{ color: var(--gx-orange); }
.gx-addr__select--purple{ color: #722ed1; }
.gx-addr__region-ok {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 6px 10px;
  border-radius: 5px;
  background: #F6FFED;
  border: 1px solid #B7EB8F;
  font-size: 11px;
  color: #52C41A;
}
.gx-addr__preview {
  padding: 12px 14px;
  border-radius: 8px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
}
.gx-addr__preview-title {
  font-size: 11px;
  color:var(--gx-red);
  font-weight: 600;
  margin-bottom: 5px;
}
.gx-addr__preview-text {
  font-size: 13px;
  color: #1A1A2E;
  line-height: 1.7;
}
.gx-addr__preview-name {
  color:var(--gx-red);
  font-weight: 500;
}
.gx-addr__preview-sep {
  color: #6A6A8A;
  margin: 0 8px;
}
.gx-addr__mono {
  font-family: 'JetBrains Mono', monospace;
}
.gx-addr__foot {
  display: flex;
  gap: 12px;
  padding: 8px 0 20px;
}
.gx-addr__btn {
  flex: 1;
  height: 42px;
  border-radius: 8px;
  cursor: pointer;
  background: #FFFFFF;
  border:1.5px solid rgb(224, 224, 236);
  font-size: 15px;
  font-weight: 600;
  color: #666666;
  transition: all .2s;
}
.gx-addr__btn--primary {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  border: none;
  color: #FFFFFF;
}
.gx-addr__btn:hover{
  color: var(--gx-red);
  border-color: var(--gx-red);
}
.gx-addr__btn:disabled {
  /*opacity: .7;*/
  cursor: not-allowed;
}

.gx-card{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  padding: 20px 22px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
  margin-bottom: 14px;
}
.gx-card__title{
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-family: "Noto Serif SC", serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--gx-black);
  position: relative;
  padding-left: 11px;
}
.gx-card__title::before{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: rgb(200, 68, 60);
  flex-shrink: 0;
}
.gx-card__body{
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.gx-card__label{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(26, 26, 46);
  margin-bottom: 9px;
  font-weight: 500;
}
.gx-card__col :deep(.el-input__inner){
  height: 36px;
  line-height: 1.5;
  padding: 0 10px;
  border:1px solid rgb(224, 224, 236);
  font-size: 12px;
  color: var(--gx-black);
}
.gx-card__col :deep(.el-input__inner::placeholder){
  color: #999999;
}
.gx-card__input-num{
  width: 100px;
}
.gx-card__input-num :deep(.el-input__inner){
  text-align: center;
}
.gx-card__unit{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(102, 102, 102);
  margin-left: 4px;
}
.gx-card__tip{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  margin-top: 4px;
  line-height: 1.5;
}
.gx-card__tip--top{
  font-size: 12px;
  margin-top: 0;
  margin-bottom: 18px;
  line-height: 1.6;
}
.gx-card__row{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.gx-card__range {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 12px;
}
.gx-card__divider {
  width: 100%;
  height: 1px;
  background: rgb(224, 224, 236);
}
.gx-cfg__foot{
  display: flex;
  gap: 10px;
  padding-top: 8px;
}
.gx-cfg__btn{
  height: 36px;
  padding: 0 20px;
  border-radius: 6px;
  cursor: pointer;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color: rgb(102, 102, 102);
  transition: 0.15s;
}
.gx-cfg__btn:disabled{
  cursor: not-allowed;
}
.gx-cfg__btn--mi{
  height: 26px;
  padding: 0px 12px;
  border-radius: 4px;
  font-size: 11px;
}
.gx-cfg__btn--red{
  background: rgb(200, 68, 60);
  font-weight: 500;
  color: rgb(255, 255, 255);
}
.gx-card__check-group{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px 20px;
  margin-top: 12px;
}

.gx-card__radio-group{
  display: flex;
  /* flex-direction: column; */
  gap: 36px;
  margin: 13px 0;
}
.gx-card__radio {
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  font-size: 12px;
  color: #1A1A2E;
  user-select: none;
}
.gx-card__radio-dot{
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 2px solid rgb(224, 224, 236);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-card__radio--on{
  color: var(--gx-red);
}
.gx-card__radio--on .gx-card__radio-dot{
  border-color:var(--gx-red);
  position: relative;
}
.gx-card__radio--on .gx-card__radio-dot::after{
  content: "";
  position: absolute;
  top:2px;
  left: 2px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgb(200, 68, 60);
}

.gx-card__example{
  margin-top: 16px;
  padding: 10px 14px;
  border-radius: 6px;
  background: rgb(245, 240, 232);
  border: 1px solid rgb(224, 224, 236);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--gx-black);
  font-size: 12px;
  font-family: "Noto Sans SC", sans-serif;
}
@media (max-width: 700px) {
  .gx-addr__region {
    grid-template-columns: 1fr 1fr;
  }
  .gx-addr__reason-grid {
    grid-template-columns: 1fr;
  }
}
</style>
